export default function AiLogo({ additionalStyles, alt = "" }) {
    const baseStyles = {
        transform: "rotate(180deg)",
    };

    return (
        <img
            alt={alt}
            style={{
                ...baseStyles,
                ...additionalStyles,
            }}
            src="/make_ai_logo.svg"
        />
    );
}
